module.exports = __webpack_public_path__ + "static/img/282_TO8_2425.b8f01ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/282_TO8_2425.jpg
// module id = /1he
// module chunks = 0